import React from 'react'
import { Box, Typography, LinearProgress } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 19,
  borderRadius: 5,
}))
export default function UserTarget({ report }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const value = 47
  return (
    <Box display={'flex'} flexDirection={'column'} height={'100%'}>
      <Box>
        <Box display={'flex'} sx={{ fontSize: 20, fontWeight: 500 }}>
          {/* LAP-733 (GE022) */}
          <Box>{t('investments.portfolio.invValue.title')}</Box>
          <Box ml={'auto'}>{report?.total} €</Box>
        </Box>
        <Box sx={{ display: 'flex' }}>
          {/* LAP-733 (GE022) */}
          <Box sx={{ color: 'gray' }}>{t('investments.portfolio.invValue.yearlyChange')}</Box>
          <Box sx={{ marginLeft: 'auto', color: 'green' }}>{report?.change}%</Box>
        </Box>
      </Box>
      <Box mt={1} height={'100%'} px={1}>
        <Box sx={{ width: '100%', position: 'relative', mt: 4, mb: 3 }}>
          <Box display={'flex'} mb={1}>
            {/* LAP-733 (GE022) */}
            <Typography variant="body1" color="white">
              {t('investments.portfolio.target.passiveIncome')}
            </Typography>
            <Typography sx={{ ml: 'auto' }} variant="body1" color="white">
              {report?.income?.objective} €
            </Typography>
          </Box>
          <BorderLinearProgress variant="determinate" value={report?.income?.change} />
          <Box
            sx={{
              position: 'absolute',
              top: 52,
              left: `${Math.max(5, Math.min(report?.income?.change, 95))}%`,
              transform: 'translateX(-50%)',
            }}
          >
            <Typography variant="body2" color="gray" style={{ whiteSpace: 'nowrap' }}>
              {report?.income?.current} €
            </Typography>
          </Box>
        </Box>

        <Box sx={{ width: '100%', position: 'relative', mt: 4, mb: 3 }}>
          <Box display={'flex'} mb={1}>
            {/* LAP-733 (GE022) */}
            <Typography variant="body1" color="white">
              {t('investments.portfolio.target.investmentReturn')}
            </Typography>
            <Typography sx={{ ml: 'auto' }} variant="body1" color="white">
              {report?.return?.objective} %
            </Typography>
          </Box>
          <BorderLinearProgress variant="determinate" value={report?.return?.change} />
          <Box
            sx={{
              position: 'absolute',
              top: 52,
              left: `${Math.max(5, Math.min(report?.return?.change, 95))}%`,
              transform: 'translateX(-50%)',
            }}
          >
            <Typography variant="body2" color="gray" style={{ whiteSpace: 'nowrap' }}>
              {report?.return?.change} %
            </Typography>
          </Box>
        </Box>

        <Box sx={{ width: '100%', position: 'relative', mt: 4, mb: 3 }}>
          <Box display={'flex'} mb={1}>
            {/* LAP-733 (GE022) */}
            <Typography variant="body1" color="white">
              {t('investments.portfolio.target.annualGrowth')}
            </Typography>
            <Typography sx={{ ml: 'auto' }} variant="body1" color="white">
              {report?.growth?.objective} %
            </Typography>
          </Box>
          <BorderLinearProgress variant="determinate" value={report?.growth?.change} />
          <Box
            sx={{
              position: 'absolute',
              top: 52,
              left: `${Math.max(5, Math.min(report?.growth?.change, 95))}%`,
              transform: 'translateX(-50%)',
            }}
          >
            <Typography variant="body2" color="gray" style={{ whiteSpace: 'nowrap' }}>
              {report?.growth?.change} %
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
